import { render, staticRenderFns } from "./OpenSLAs.vue?vue&type=template&id=208c6b04&scoped=true"
import script from "./OpenSLAs.vue?vue&type=script&lang=js"
export * from "./OpenSLAs.vue?vue&type=script&lang=js"
import style0 from "./OpenSLAs.vue?vue&type=style&index=0&id=208c6b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c6b04",
  null
  
)

export default component.exports